import { SET_CATEGORY } from "./mutations";
import { store } from "../../index";

export const selectCategory = (name) => {
  let { categorySelection } = store.getState().category;
  if(!categorySelection) categorySelection = { objectName: "categorySelection" };

  if(categorySelection.hasOwnProperty(name)) return categorySelection[name];
};

export const updateCategory = (name, category) => async (dispatch) => {
  //save item name and category in the store
  const { categorySelection } = store.getState().category;
  let _categorySelection = { ...categorySelection };
  _categorySelection[name] = category;

  dispatch({
    type: SET_CATEGORY,
    payload: _categorySelection,
  });
};

export const setCategoryData = (category) => ({
  type: SET_CATEGORY,
  payload: category,
});